import System from '@/_system.js'

export default {
  methods: {
    async writeFile (filename, imageData) {
      await System.writeFile({
        path: filename,
        data: imageData,
      })
    },
  },
}
